const statementTableDictIT = {
  financial: "Finanziario",
  extracredit: "Extracredit",
  wallet: "Portafoglio",
  walletStatement: "Estratto conto portafoglio",
  extracoinStatement: "Estratto di Extracredit",
  extrabonusStatement: "Estratto Bonus Ads",
  bonusStatement: "Estratto di rendita giornaliera a vita",
  planNotAllowed: "Il tuo piano attuale non ha accesso a questa risorsa.",
  statementSubtitle: "Segui le operazioni effettuate sul tuo portafoglio utilizzando Extracredit.",
  showingFirstToLast: "Visualizzazione da {first} a {last} di {totalRecords}",
  noOperationsRecords: "Ancora nessun record di operazioni.",
  date: "Data",
  from: "Dal",
  toFrom: "Al",
  check: "Verifica",
  statement: "Estratto",
  description: "Descrizione",
  inbound: "Credito",
  outbound: "Debito",
  status: "Stato",
  dateTransaction: "Data della Transazione",
  emptyDates: "Si prega di scegliere un periodo di due date.",
  completed: "Completato",
  pending: "Pendente",
  pendingVoucher: "Buono in attesa",
  canceled: "Annullata",
};

export default statementTableDictIT;
